module.exports = __webpack_public_path__ + "static/img/img-3.4e0807a4.jpg";